import EditConditionDropDown from "./EditConditionDropDown"
import EditUserReferenceConditionDropDown from "./EditUserReferenceConditionDropDown"
import EditInternalContactConditionDropDown from "./EditInternalContactConditionDropDown"
import EditDateConditionDropDown from "./EditDateConditionDropDown"

export { default as AddConditionDropDown } from "./AddConditionDropDown"
export { default as EditSpacialTypeDistanceConditionDropDown } from "./EditSpacialTypeDistanceConditionDropDown"

export default function DropDowns({ field, condition, ...rest }) {
  const props = {
    field,
    condition,
    ...rest,
  }

  if (field.kind === "Date") {
    return <EditDateConditionDropDown {...props} />
  }

  if (field.kind === "InternalContact") {
    return <EditInternalContactConditionDropDown {...props} />
  }

  if (field.kind === "User") {
    return <EditUserReferenceConditionDropDown {...props} />
  }

  return <EditConditionDropDown {...props} />
}
